module.exports = __webpack_public_path__ + "static/assets/98bfc66ce081a3750f3b59ab67d0ac75.svg";